import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutModule } from '../../../layouts/layout.module';

import { BlockUIModule } from 'ng-block-ui';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';

import { UsersRoutingModule } from './users-routing.module';
import { UsersMainComponent } from './users-main/users-main.component';
import { UsersListComponent } from './users-list/users-list.component';
import { ApiModule } from '../../../../_services/api.module';
import { TableModule } from '../../../../shared/table';
import { WidgetModule } from '../../../../shared/widget';
import { FilterModule } from '../../../../shared/filter';
import { UsersNewComponent } from './users-new/users-new.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    imports: [
        CommonModule,
        UsersRoutingModule,
        LayoutModule,
        TableModule,
        FilterModule,
        BlockUIModule.forRoot(),
        SweetAlert2Module.forRoot(),
        ApiModule,
        FormsModule,
        NgbModule,
        NgbModule.forRoot(),
        WidgetModule
    ],
    providers: [NgbActiveModal],
    declarations: [UsersMainComponent, UsersListComponent, UsersNewComponent]
})
export class UsersModule { }



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/users/users.module.ts